import Header from './Header';

export * from './HeaderProps';
export default Header;
